import { application, IApplicationState } from "./application";
import {
  accessCredentials,
  IIAMAccessCredentialsState,
} from "./access-credentials";
import { bucket, IBucketState } from "./bucket";
import { combineReducers } from "redux";
import { IShardRepositoryState, shardRepository } from "./shard-repository";
import users, { IUsersState } from "./users";
import storage, { IStorageState } from "./storage";
import common, { ICommonState } from "./common";
import account, { IAccountState } from "./account";
import { IRequestParams } from "../../api/entities/page";
import { IShardClusterState, shardCluster } from "./shard-cluster";
import enterpriseAccountSetup, {
  IEnterpriseAccountSetupState,
} from "./enterprise-account-setup";
import { ITooltipUserGuideState, tooltipUserGuide } from "./tooltip-user-guide";
import { iamEntity, IIAMEntityState } from "./iam-entity";
import { IStorageProviderState, storageProvider } from "./storage-provider";

const userApp = combineReducers({
  users,
  storage,
  common,
  enterpriseAccountSetup,
  account,
  shardRepository,
  shardCluster,
  application,
  // applicationCredentials,
  accessCredentials,
  iamEntity,
  bucket,
  tooltipUserGuide,
  storageProvider,
});

export interface IAppState {
  users: IUsersState;
  storage: IStorageState;
  common: ICommonState;
  enterpriseAccountSetup: IEnterpriseAccountSetupState;
  account: IAccountState;
  shardRepository: IShardRepositoryState;
  shardCluster: IShardClusterState;
  application: IApplicationState;
  // applicationCredentials: IApplicationCredentialsState;
  accessCredentials: IIAMAccessCredentialsState;
  iamEntity: IIAMEntityState;
  bucket: IBucketState;
  tooltipUserGuide: ITooltipUserGuideState;
  storageProvider: IStorageProviderState;
}

export interface IDialogState<TDialogData> {
  isOpen: boolean;
  data: TDialogData;
}

export interface IEntitiesPageState<
  TEntity,
  TSortField,
  TSearchParams extends IRequestParams<TSortField>
> {
  entities: TEntity[];
  searchParams: TSearchParams;
  count: number;
  isLoading: boolean;
}

export default userApp;
